import { FC } from 'react';
// components
import VeganTypeRadioGroup from 'components/main/Formulas/Dosage/Add/components/VeganTypeRadioGroup';

const BCAA: FC = () => <VeganTypeRadioGroup />;

export default BCAA;
